<div class="picker-autocomplete">
  <div class="control-container">
    <div *ngIf="title" class="centered-row-container-flex-start">
      <label [for]="inputID" class="input-title" [class.red-10]="errorProperties.errorState">
        {{title}}
      </label>
      <span *ngIf="errorProperties.required" class="red-10 line-height-80">*</span>
    </div>
    <div class="input-autocomplete-container {{additionalContainerClass}}"
      [style]="zIndex ? 'z-index: ' + zIndex : ''"
      >
      <input
        data-qa="input-auto-complete"
        class="input-autocomplete cursor-pointer {{inputHeightClass}}"
        [class.control-shrinked-container]="isShrinked"
        [class.input-error]="errorProperties.errorState"
        [id]="inputID"
        [disabled]="isDisabled"
        [placeholder]="placeHolder"
        [(ngModel)]="selectedObject"
        (change)="emitValue(selectedObject)"
        (input)="inputChange($event.target.value)">
        <!-- user select none is used to ignore icon and to open dropdown on icon click as well-->
        <app-all-icons class="no-propagation user-select-none"
          [iconNameAndStyling]="'arrow-down.svg; opacity0p64; icon-size-1p125'"/>
      <div class="picker centered-column-container">
        <div class="picker-dropdown centered-column-container">
          <div data-qa="input-auto-complete-picker-list"
            class="centered-column-container picker-list">
            <div *ngFor="let obj of filteredData | async; let i = index" class="centered-column-container list-block">
              <span
                [attr.data-qa]="dataQA + '-list-entry-' + i"
                class="list-entry"
                (click)="updateAndEmitSelectedValue(obj)"
              >
                {{ (isSimpleArray ? obj : obj[field]) | linkShort:maxListEntryLength}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="errorProperties.errorState" class="input-text-error font-4">{{errorProperties.bottomText}}</div>
</div>
